import * as constants from '../constants'

export const setOcppTags = (ocppTags) => {
  return {
    type: constants.SET_OCPPTAGS,
    ocppTags,
  }
}
